import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    id: undefined,
    title: '',
    kind: 'onoff',
    code: '',
    unit: '',
    comment: '',
};
export const slice = createSlice({
    name: 'edit_transmitter_dialog',
    initialState,
    reducers: {
        newEditTransmitterDialog(state) {
            state.id = undefined;
            state.title = '';
            state.kind = 'onoff';
            state.code = '';
            state.unit = '';
            state.comment = '';
        },
        setEditTransmitterDialog(state, action) {
            state.id = action.payload.id;
            state.title = action.payload.title;
            state.kind = action.payload.kind;
            state.code = action.payload.code;
            state.unit = action.payload.unit;
            state.comment = action.payload.comment;
        },
        setEditTransmitterDialogTitle(state, action) {
            state.title = action.payload;
        },
        setEditTransmitterDialogKind(state, action) {
            state.kind = action.payload;
        },
        setEditTransmitterDialogCode(state, action) {
            state.code = action.payload;
        },
        setEditTransmitterDialogUnit(state, action) {
            state.unit = action.payload;
        },
        setEditTransmitterDialogComment(state, action) {
            state.comment = action.payload;
        },
    }
});
export const { newEditTransmitterDialog, setEditTransmitterDialog, setEditTransmitterDialogTitle, setEditTransmitterDialogKind, setEditTransmitterDialogCode, setEditTransmitterDialogUnit, setEditTransmitterDialogComment, } = slice.actions;
export const edit_transmitter_dialog = slice.reducer;
